import request from '../utils/request';
//培训通知
export function getInfoMessageList(data) {
  return request({
    url: '/info/getInfoMessageList.html',
    method: 'post',
    data,
  })
}

//我的消息
export function getUserNotice(data) {
  return request({
    url: '/user/getUserNotice.do',
    method: 'post',
     data,
  })
}
//消息详情
export function getNoticeDetail(query) {
  return request({
    url: '/user/getNoticeDetail.do',
    method: 'get',
     params: query,
  })
}
//资讯详情
export function toInfoMessageDetail(query) {
  return request({
    url: '/info/toInfoMessageDetail.html',
    method: 'get',
     params: query,
  })
}
//通知详情
export function getInfoMessageDetail(data) {
  return request({
    url: '/info/getInfoMessageDetail.html',
    method: 'post',
    data,
  })
}

//学时证明
export function toCreditZM(data) {
  return request({
    url: '/learning/toCreditZM.html',
    method: 'post',
    data
  });
}
